import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`;

export const Side = styled.div`
  margin-right: 20px;
  max-width: 300px;
  width: 100%;
  
  flex-shrink: 0;
  row-gap: 10px;
  display: grid;
`;

export const Content = styled.div`
  row-gap: 10px;
  display: grid;
  width: 100%;
`;
